import { render, staticRenderFns } from "./AcceptOwnership.vue?vue&type=template&id=db672088"
import script from "./AcceptOwnership.vue?vue&type=script&lang=js"
export * from "./AcceptOwnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports